import { Col,  Form,  Modal, Row,  DatePicker,Input,Button,App, Spin, Space, Divider } from 'antd';
import { ASSETS_APPLICATION_BASE } from '../../config/api';
import { useEffect, useState} from 'react'
import classes from './report.module.css'  
import dayjs from 'dayjs';
import { useBaozhangdanUpdateSaveMutation, useBaozhangdanUpdateQuery } from '../../store/DianShangYeWuApi';
// import ReportCheckNode from './ReportCheckNode';  
import ClientSelect from '../../system/client/ClientSelect';
import ReportDeptSelect from '../../system/dept/DeptSelect';
import ReportOpSelect from './ReportOpSelect';
import OCRTextArea from '../../cpn/OCRTextArea';
import UploadPic from '../../cpn/UploadPic';         
import StateTag from '../../cpn/StateTag';
import ReportDel from './ReportDel';
import Icon from '../../cpn/Icon';
import ReportSubmit from './ReportSubmit';
import Asterisk from '../../cpn/Asterisk';
import DocumentRule from '../../cpn/DocumentRule';
import ClientContactSelect from '../../system/client/ClientContactSelect';
import IncomeListReport from '../income/IncomeListReport';
import CostListReport from '../cost/CostListReport';
import ExpenseListReport from '../expense/ExpenseListReport';
import LoanListReport from '../loan/LoanListReport';
import InvoiceListReport from '../../invoice/invoice/InvoiceListReport';
const {RangePicker} = DatePicker;
function ReportEdit(props) {
    const { message } = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false)
    const [info, setInfo] = useState({
        sr_data: [],
        zc_data: [],
        jk_data: [],
        kpsq_data: [],
        fy_data: [],
        dsbzd_khlxr_id: '',
        dsbzd_khlxr_name: '',
    })
    const [defaultFileList, setDefaultFileList] = useState([])
    
    // 自动打开 Modal（用于新增成功后自动打开）
    useEffect(() => {
        if (props.autoOpen && props.dsbzd_id) {
            // console.log('自动打开 ReportEdit Modal, dsbzd_id:', props.dsbzd_id);
            setOpen(true);
        }
    }, [props.autoOpen, props.dsbzd_id]);

    // 当 props 中没有完整数据时，通过 API 获取数据
  
    const { data: updateData, isSuccess: updateIsSuccess, isFetching: updateIsFetching } = useBaozhangdanUpdateQuery(
        { dsbzd_id: props.dsbzd_id }, 
        { skip: !open , refetchOnMountOrArgChange: 1 }
    );


    // 当 Modal 打开时设置表单默认值（从API获取的数据）
    useEffect(() => {
        if(updateIsSuccess && updateData && updateData.Status === 'success' && updateData.Result){
            const result = updateData.Result;
            setInfo(prevState=>({...prevState,
                dsbzd_id: result.dsbzd_id || '',
                dsbzd_qy_id: result.dsbzd_qy_id || '',
                dsbzd_qy_name: result.dsbzd_qy_name || '',
                dsbzd_name: result.dsbzd_name || '',
                dsbzd_uname: result.dsbzd_uname || '',
                dsbzd_ctime: result.dsbzd_ctime || '',
                dsbzd_content: result.dsbzd_content || '',
                dsbzd_date: result.dsbzd_date || '',
                dsbzd_date_end: result.dsbzd_date_end || '',
                dsbzd_dscp_id: result.dsbzd_dscp_id || '',
                dsbzd_dscp_name: result.dsbzd_dscp_name || '',
                dsbzd_dspt_id: result.dsbzd_dspt_id || '',
                dsbzd_dspt_name: result.dsbzd_dspt_name || '',
                dsbzd_zb_id: result.dsbzd_zb_id || '',
                dsbzd_zb_name: result.dsbzd_zb_name || '',
                dsbzd_jd_id: result.dsbzd_jd_id || '',
                dsbzd_jd_name: result.dsbzd_jd_name || '',
                dsbzd_kh_id: result.dsbzd_kh_id || '',
                dsbzd_kh_name: result.dsbzd_kh_name || '',
                dsbzd_khlxr_id: result.dsbzd_khlxr_id || '',
                dsbzd_khlxr_name: result.dsbzd_khlxr_name || '',
                dsbzd_bm_id: result.dsbzd_bm_id || '',
                dsbzd_bm_name: result.dsbzd_bm_name || '',
                dsbzd_image_file: Array.isArray(result.dsbzd_image_file) ? result.dsbzd_image_file : (result.dsbzd_image_file ? [result.dsbzd_image_file] : []),
                dsbzd_image_name: Array.isArray(result.dsbzd_image_name) ? result.dsbzd_image_name : (result.dsbzd_image_name ? [result.dsbzd_image_name] : []),
                fy_data: result.fy_data || [],
                sr_data: result.sr_data || [],
                zc_data: result.zc_data || [],
                jk_data: result.jk_data || [],
                kpsq_data: result.kpsq_data || [],
                dsbzd_uid: result.dsbzd_uid || '',
                dsbzd_state: result.dsbzd_state || '',
            }));
            setDefaultFileList(Array.isArray(result.dsbzd_image_name) ? result.dsbzd_image_name.filter(Boolean) : []);
            if (open && props.dsbzd_id) {
                // 将数组格式的文件数据转换为文件对象数组
                const imageNameArray = Array.isArray(result.dsbzd_image_name) 
                    ? result.dsbzd_image_name.filter(Boolean)
                    : (result.dsbzd_image_name ? [result.dsbzd_image_name] : []);
                const imageFileArray = Array.isArray(result.dsbzd_image_file)
                    ? result.dsbzd_image_file.filter(Boolean)
                    : (result.dsbzd_image_file ? [result.dsbzd_image_file] : []);
                
                const fileListForForm = imageNameArray.map((serverFileName, i) => {
                    // 确保 URL 是完整路径
                    // 根据 setupProxy.js，/api 代理到 fxapi.zzddww.com，用于访问图片
                    let fullUrl = serverFileName;
                    if (serverFileName.startsWith('http://')) {
                        // 完整 URL，直接使用
                        fullUrl = serverFileName;
                    } else if (serverFileName.startsWith('/')) {
                        // 已经是相对路径，检查是否需要添加 /api 前缀
                        if (!serverFileName.startsWith('/api/') && !serverFileName.startsWith('/NeiZhangApi/')) {
                            fullUrl = `/api${serverFileName}`;
                        } else {
                            fullUrl = serverFileName;
                        }
                    } else {
                        // 只是文件名，使用 /api/assets/images/application/ 路径
                        fullUrl = `${ASSETS_APPLICATION_BASE}/${serverFileName}`;
                    }
                    
                    // 获取显示名称
                    const displayName = imageFileArray[i] || undefined;
                    
                    return {
                        uid: `file-${i}-${serverFileName}`,
                        name: displayName || serverFileName || `文件${i + 1}`,
                        status: 'done',
                        url: fullUrl,
                        response: {
                            Result: serverFileName // 保存服务器文件名用于提交
                        }
                    };
                });
                
                setTimeout(() => {
                    form.setFieldsValue({
                        dsbzd_content:  result.dsbzd_content,           
                        dsbzd_date: result.dsbzd_date ? [dayjs(result.dsbzd_date), dayjs(result.dsbzd_date_end)] : null,    
                        dsbzd_dscp_id: result.dsbzd_dscp_id,
                        dsbzd_dscp_name: result.dsbzd_dscp_name,
                        dsbzd_dspt_id: result.dsbzd_dspt_id,
                        dsbzd_dspt_name: result.dsbzd_dspt_name,
                        dsbzd_zb_id: result.dsbzd_zb_id,
                        dsbzd_zb_name: result.dsbzd_zb_name,
                        dsbzd_jd_id: result.dsbzd_jd_id,        
                        dsbzd_jd_name: result.dsbzd_jd_name,
                        dsbzd_kh_id: result.dsbzd_kh_id,
                        dsbzd_kh_name: result.dsbzd_kh_name,
                        dsbzd_month: result.dsbzd_month,
                        dsbzd_qy_id: result.dsbzd_qy_id,
                        dsbzd_year: result.dsbzd_year,
                        dsbzd_danhao: result.dsbzd_danhao,
                        dsbzd_name: result.dsbzd_name,
                        dsbzd_bm_name: result.dsbzd_bm_name,
                        dsbzd_bm_id: result.dsbzd_bm_id,
                        dsbzd_khlxr_id: result.dsbzd_khlxr_id,
                        dsbzd_khlxr_name: result.dsbzd_khlxr_name,
                        dsbzd_image_file: fileListForForm, // 使用转换后的文件对象数组
                        dsbzd_image_name: imageNameArray,
                    });
                }, 0);
            }
        
        }
    }, [updateIsSuccess, updateData, form,open,props.dsbzd_id]);
    //修改保存
    const [updateSave] = useBaozhangdanUpdateSaveMutation();
    // 格式化金额显示
    const formatCurrency = (amount) => {
        return `￥${Number(amount).toLocaleString('zh-CN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })}`;
    };
    return (
        <>
            <a onClick={() => { setOpen(true)}}>{props.dsbzd_name}</a>
            <Modal
                open={open}
                width={1330}
                onCancel={() => {
                    setOpen(false);
                    // 延迟重置表单，避免在Modal关闭动画期间操作form
                    setTimeout(() => {
                        form.resetFields();
                    }, 100);
                    // 通知父组件 Modal 已关闭
                    if (props.onClose) {
                        props.onClose();
                    }
                }}                       
                footer={[<Button key='cancel' onClick={() => {setOpen(false)}}>关闭</Button>,]}
            >
                <Spin spinning={open && updateIsFetching} tip="数据加载中...">
                <Form
                    form={form}
                    layout="horizontal"
                    name={`form_edit_${props.dsbzd_id || 'new'}`}
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3}}
                    wrapperCol={{ span: 21 }}   
                    variant='filled'
                    size='middle'                      
                    style={{ maxWidth: 1280 }}
                >    
                    <Row>
                        <Col span={3}></Col>
                        <Col span={18}><div style={{fontSize: '18px', fontWeight: 'bold', textAlign: 'center', marginBottom: '10px'}}>团队报账单</div></Col>
                        <Col span={3}></Col>
                    </Row>
                    <Row style={{width:"1280px"}}>
                        {/* 第一行 */}
                        <Col span={2} className={classes.col_top_label} style={{borderLeft: '3px solid #000', borderTop: '3px solid #000'}}><Asterisk color='red'/> 团队名称</Col>
                        <Col span={6}  className={classes.col_top_input} style={{borderTop: '3px solid #000'}}>
                            <Form.Item name="dsbzd_name" noStyle>
                                <Input 
                                    placeholder="请输入团队名称" 
                                    style={{ width: '100%' }} 
                                    onChange={(e) => {
                                        setInfo(prevState=>({
                                            ...prevState,
                                            dsbzd_name:e.target.value,
                                        }))
                                    }}
                                />
                            </Form.Item>
                        </Col>  
                        <Col span={2} className={classes.col_top_label} style={{borderTop: '3px solid #000'}}><Asterisk color='red'/>部门</Col>
                        <Col span={6}  className={classes.col_top_input} style={{borderTop: '3px solid #000'}}>
                            <ReportDeptSelect
                                yh_id={props.yh_id}          
                                wrapperCol={{span:24}}
                                placeholder='请选择部门'
                                qy_id={props.qy_id}
                                onChange={(e,f) => {                                                
                                    setInfo(prevState=>({...prevState,dsbzd_bm_id:e,dsbzd_bm_name:f}))
                                }}
                                name="dsbzd_bm_name"
                                defaultId={info.dsbzd_bm_id}
                                style={{width: '310px'}}
                                formStyle={{marginBottom: 0,width: '100%'}}
                                list={props.commonList.bm_data}
                                onClear={() => {
                                    setInfo(prevState=>({...prevState,dsbzd_bm_id:'',dsbzd_bm_name:''}))
                                }}
                            />
                        </Col>  
                        <Col span={2}  className={classes.col_top_label} style={{borderTop: '3px solid #000'}}>收款单</Col>
                        <Col span={6}  className={classes.col_right_input} style={{borderTop: '3px solid #000',borderRight:"3px solid #000"}}>
                            共{info.sr_data?.length || 0}张，合计{formatCurrency((info.sr_data || []).reduce((sum, row) => sum + Number(row.ddsr_amount || 0), 0))}
                        </Col> 
                        {/* 第二行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft: '3px solid #000',}}><Asterisk color='red'/> 起止日期</Col>
                        <Col span={6}  className={classes.col_middle_input} style={{padding:'0 5px',justifyContent:'space-between'}}>
                            <Form.Item 
                                name="dsbzd_date" 
                                noStyle
                                rules={[{required: true, message: '请选择开始日期'}]}
                            >
                                <RangePicker 
                                    style={{ width: '260px' }} 
                                    onChange={(e) => {
                                        setInfo(prevState=>({
                                            ...prevState,
                                            dsbzd_date:dayjs(e[0]).format('YYYY-MM-DD'),
                                            dsbzd_date_end:dayjs(e[1]).format('YYYY-MM-DD'),
                                            dsbzd_month:dayjs(e[0]).format('YYYY-MM'),
                                            dsbzd_year:dayjs(e[0]).format('YYYY'),
                                        }))
                                    }}
                                />
                            </Form.Item>
                            {(dayjs(info.dsbzd_date_end).diff(dayjs(info.dsbzd_date), 'day') + 1) > 0 ?  ' 共' + (dayjs(info.dsbzd_date_end).diff(dayjs(info.dsbzd_date), 'day') + 1) + '天 ' : ''}
                        </Col>
                        <Col span={2} className={classes.col_bottom_label}><Asterisk color='red'/>计调</Col>               
                        <Col span={6} className={classes.col_bottom_input}>
                            <ReportOpSelect
                                yh_id={props.yh_id}          
                                wrapperCol={{span:24}}
                                placeholder='请选择计调'
                                qy_id={props.qy_id}
                                onChange={(e,f) => {                                                
                                    setInfo(prevState=>({...prevState,dsbzd_jd_id:e,dsbzd_jd_name:f}))
                                }}
                                name="dsbzd_jd_name"
                                defaultId={info.dsbzd_jd_id}
                                style={{width: '310px'}}
                                formStyle={{marginBottom: 0,width: '100%'}}
                                list={props.commonList.jd_data}
                                onClear={() => {
                                    setInfo(prevState=>({...prevState,dsbzd_jd_id:'',dsbzd_jd_name:''}))
                                }}
                            />
                        </Col>                     
                        <Col span={2}  className={classes.col_middle_label}>付款单</Col>
                        <Col span={6}  className={classes.col_middle_right_input} style={{borderRight:"3px solid #000"}}>
                            共{info.zc_data?.length || 0}张，合计{formatCurrency((info.zc_data || []).reduce((sum, row) => sum + Number(row.ddzc_amount || 0), 0))}
                        </Col> 
                        {/* 第三行 */}                         
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft: '3px solid #000'}}><Asterisk color='red'/> 客户</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                            <ClientSelect
                                yh_id={props.yh_id}          
                                wrapperCol={{span:24}}
                                placeholder='请选择客户'
                                qy_id={props.qy_id}
                                qy_name={props.qy_name}
                                yh_name={props.yh_name}
                                onChange={(e,f,g,h) => {                                                
                                    setInfo(prevState=>({
                                        ...prevState,
                                        dsbzd_kh_id:e || '',
                                        dsbzd_kh_name:f || '',
                                        dsbzd_khlxr_id:'',
                                        dsbzd_khlxr_name:'',
                                        dsbzd_dscp_id:g || '',
                                        dsbzd_dscp_name:h || '',
                                    }))
                                }}
                                onClear={() => {
                                    setInfo(prevState=>({
                                        ...prevState,
                                        dsbzd_kh_id:'',
                                        dsbzd_kh_name:'',
                                        dsbzd_khlxr_id:'',
                                        dsbzd_khlxr_name:'',
                                        dsbzd_dscp_id:'',
                                        dsbzd_dscp_name:'',
                                    }))
                                }}
                                style={{width: '230px'}}
                                formStyle={{marginBottom: 0,width: '100%'}}
                                list={props.commonList.kh_data}
                                name="dsbzd_kh_id"
                                clientAdd={true}
                            />
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}>客户部门</Col>
                        <Col span={6}  className={classes.col_middle_input}>                             
                            {info.dsbzd_kh_id &&
                                <ClientContactSelect
                                    yh_id={props.yh_id}    
                                    yh_name={props.yh_name}      
                                    qy_id={props.qy_id}
                                    qy_name={props.qy_name}
                                    wrapperCol={{span:24}}
                                    placeholder='请选择对接人'
                                    kh_id={info.dsbzd_kh_id}
                                    formStyle={{marginBottom: 0,width: '100%'}}
                                    onChange={(e,f) => {
                                        setInfo(prevState=>({...prevState,dsbzd_dscp_id:e || '',dsbzd_dscp_name:f || ''}))
                                    }}
                                    name="dsbzd_dscp_name"
                                />
                            }
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}>毛收入</Col>
                        <Col span={6}  className={classes.col_middle_right_input} style={{borderRight:"3px solid #000"}}>
                            {formatCurrency(
                                ((info.sr_data || []).reduce((sum, row) => sum + Number(row.ddsr_amount || 0), 0)) -
                                ((info.zc_data || []).reduce((sum, row) => sum + Number(row.ddzc_amount || 0), 0))
                            )}
                        </Col>                        
                        {/* 第四行 */}
                        <Col span={2} className={classes.col_middle_label} style={{borderLeft: '3px solid #000'}}><Asterisk color='red'/>对接人</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                            <Form.Item name="dsbzd_dspt_name" noStyle>   
                                <Input placeholder='请填写对接人' onChange={(e) => {
                                    setInfo(prevState=>({...prevState,dsbzd_dspt_id:e.target.value,dsbzd_dspt_name:e.target.value}))
                                }} style={{width: '100%'}} />
                            </Form.Item>
                        </Col>                                    
                        <Col span={2}  className={classes.col_middle_label}>备注</Col>
                        <Col span={6}  className={classes.col_middle_input}> 
                            <Form.Item name="dsbzd_content" noStyle>   
                                <OCRTextArea
                                    value={info.dsbzd_content}
                                    onChange={(e) => {
                                        setInfo(prevState=>({...prevState,dsbzd_content:e.target.value}))
                                    }}
                                    language="chi_sim"
                                />
                            </Form.Item>
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}>费用单</Col>
                        <Col span={6}  className={classes.col_middle_right_input} style={{borderRight:"3px solid #000"}}>     
                            共{info.fy_data?.length || 0}张，合计{formatCurrency((info.fy_data || []).reduce((sum, row) => sum + Number(row.fy_amount || 0), 0))}
                        </Col> 
                        {/* 第五行 */}
                        <Col span={2} className={classes.col_middle_label} style={{borderLeft: '3px solid #000'}}>附件</Col>
                        <Col span={6}  className={classes.col_middle_input} style={{padding:'10px 5px'}}>
                            <UploadPic
                                name="dsbzd_image_file"
                                defaultFileList={defaultFileList}
                                onChange={(fileNames, fileUrls) => {
                                    // fileNames: 显示名称数组
                                    // fileUrls: 服务器文件路径数组
                                    setInfo(prevState=>({
                                        ...prevState,
                                        dsbzd_image_file: Array.isArray(fileNames) ? fileNames : (fileNames ? [fileNames] : []),
                                        dsbzd_image_name: Array.isArray(fileUrls) ? fileUrls : (fileUrls ? [fileUrls] : [])
                                    }))
                                }}
                                maxCount={5}
                                accept="image/*"
                                width="100%"
                                formStyle={{marginBottom: 0,width: '100%'}}
                            />
                        </Col>   
                        <Col span={2}  className={classes.col_middle_label}>编号</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                            <Space>
                            {props.dsbzd_id} <StateTag state={info.dsbzd_state} />
                            </Space>
                        </Col>                                                        
                        <Col span={2}  className={classes.col_middle_label}>净收入</Col>
                        <Col span={6}  className={classes.col_middle_right_input} style={{borderRight:"3px solid #000"}}>
                            {formatCurrency(
                                ((info.sr_data || []).reduce((sum, row) => sum + Number(row.ddsr_amount || 0), 0)) -
                                ((info.zc_data || []).reduce((sum, row) => sum + Number(row.ddzc_amount || 0), 0)) -
                                ((info.fy_data || []).reduce((sum, row) => sum + Number(row.fy_amount || 0), 0))
                            )}，净收入率 
                            {((info.sr_data || []).reduce((sum, row) => sum + Number(row.ddsr_amount || 0), 0)) > 0 ? ((((info.sr_data || []).reduce((sum, row) => sum + Number(row.ddsr_amount || 0), 0)) -
                            ((info.zc_data || []).reduce((sum, row) => sum + Number(row.ddzc_amount || 0), 0)) -
                            ((info.fy_data || []).reduce((sum, row) => sum + Number(row.fy_amount || 0), 0))) /
                            ((info.sr_data || []).reduce((sum, row) => sum + Number(row.ddsr_amount || 0), 0)) * 100).toFixed(2) : 0}%
                        </Col>           
                        {/* 第六行 */}                       
                        <Col span={24} className={classes.bottom_row} >
                            {/* {info.dsbzd_state==='2'? <ReportCheckNode qy_id={props.qy_id} yh_id={props.yh_id} yh_name={props.yh_name} dsbzd_ctime={info.dsbzd_ctime} dsbzd_id={props.dsbzd_id}/> : <ReportCheckNodePendding 
                             qy_id={props.qy_id} 
                            qy_name={props.qy_name}
                            yh_id={info.dsbzd_uid} 
                            yh_name={info.dsbzd_uname}
                            dsbzd_uid={info.dsbzd_uid} 
                            dsbzd_uname={info.dsbzd_uname}
                            dsbzd_id={props.dsbzd_id}
                            dsbzd_name={info.dsbzd_name}
                            dsbzd_date={info.dsbzd_date}
                            dsbzd_date_end={info.dsbzd_date_end}
                            dsbzd_kh_id={info.dsbzd_kh_id}
                            dsbzd_kh_name={info.dsbzd_kh_name}
                            dsbzd_state_time={info.dsbzd_state_time}
                            dsbzd_ctime={info.dsbzd_ctime}
                        />} */}
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{textAlign: 'right',paddingTop: '10px',display:'flex',justifyContent:'space-between'}}>
                            <DocumentRule/>
                            <Form.Item name="dsbzd_state" noStyle>
                                <Space size={20} >
                                    <Icon type='save' onClick={() => {
                                        if(!info.dsbzd_date || !info.dsbzd_date_end || !info.dsbzd_name || !info.dsbzd_jd_id || !info.dsbzd_kh_id || !info.dsbzd_dspt_id || !info.dsbzd_bm_id){
                                            message.error('开始日期、结束日期、团队名称、计调、客户、对接人、部门为必填项目！')
                                            return
                                        }
                                        if(dayjs(info.dsbzd_date).isAfter(dayjs(info.dsbzd_date_end))){
                                            message.error('开始日期不能大于结束日期！')
                                            return
                                        }
                                        updateSave({                        
                                            'dsbzd_qy_id': props.qy_id,
                                            'dsbzd_dspt_id': info.dsbzd_dspt_id,
                                            'dsbzd_dspt_name': info.dsbzd_dspt_name,
                                            'dsbzd_dscp_id': info.dsbzd_dscp_id,
                                            'dsbzd_dscp_name': info.dsbzd_dscp_name,
                                            'dsbzd_content': info.dsbzd_content,
                                            'dsbzd_jd_id': info.dsbzd_jd_id,
                                            'dsbzd_jd_name': info.dsbzd_jd_name,
                                            'dsbzd_zb_id': info.dsbzd_zb_id,
                                            'dsbzd_zb_name': info.dsbzd_zb_name,
                                            'dsbzd_uid': props.yh_id,
                                            'dsbzd_uname': props.yh_name,
                                            'dsbzd_id': props.dsbzd_id,
                                            'dsbzd_date': info.dsbzd_date,
                                            'dsbzd_state': '1',
                                            'dsbzd_bm_id': info.dsbzd_bm_id,
                                            'dsbzd_bm_name': info.dsbzd_bm_name,
                                            'dsbzd_kh_id': info.dsbzd_kh_id,
                                            'dsbzd_kh_name': info.dsbzd_kh_name,
                                            'dsbzd_khlxr_id': info.dsbzd_khlxr_id,
                                            'dsbzd_khlxr_name': info.dsbzd_khlxr_name,
                                            'dsbzd_qy_name': props.qy_name,  
                                            'dsbzd_image_name': info.dsbzd_image_name?info.dsbzd_image_name:'',
                                            'dsbzd_image_file': info.dsbzd_image_file?info.dsbzd_image_file:'',
                                            'dsbzd_date_end': info.dsbzd_date_end,
                                            'dsbzd_name': info.dsbzd_name,
                                        }).then((res) => {
                                            if (res.data.Status === 'success') {                            
                                                message.success('保存成功！')   
                                                setOpen(false)
                                                // 延迟重置表单，避免在Modal关闭时操作form
                                                setTimeout(() => {
                                                    form.resetFields();
                                                }, 100);      
                                                setInfo({
                                                    dsbzd_dspt_id:'',
                                                    dsbzd_dspt_name:'',
                                                    dsbzd_kh_id:"",
                                                    dsbzd_kh_name:"",
                                                    dsbzd_jd_id:'',
                                                    dsbzd_jd_name:'',
                                                    dsbzd_zb_id:'',
                                                    dsbzd_zb_name:'',
                                                    dsbzd_dscp_id:'',
                                                    dsbzd_dscp_name:'',
                                                    dsbzd_content:'',
                                                    dsbzd_date:'',
                                                    dsbzd_year:'',
                                                    dsbzd_month:'',   
                                                    dsbzd_state: '1',     
                                                    dsbzd_comments: '',
                                                    dsbzd_date_end:'',
                                                    dsbzd_bm_id:'',
                                                    dsbzd_bm_name:'',
                                                    dsbzd_image_file:[],
                                                    dsbzd_image_name:[],
                                                })                                              
                                            }
                                            if (res.data.Status === 'fail') {
                                                message.error('保存失败！'+res.data.Message)
                                            }
                                        })  
                                    }}>保存</Icon>
                                    <ReportDel dsbzd_id={props.dsbzd_id} />
                                    <ReportSubmit 
                                        dsbzd_id={props.dsbzd_id} 
                                        dsbzd_state={info.dsbzd_state} 
                                        dsbzd_state_time={info.dsbzd_state_time} 
                                        dsbzd_uid={info.dsbzd_uid} 
                                        dsbzd_uname={info.dsbzd_uname}
                                        yh_id={props.yh_id}    
                                        yh_name={props.yh_name}
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        dsbzd_name={info.dsbzd_name}
                                        dsbzd_date={info.dsbzd_date}
                                        dsbzd_date_end={info.dsbzd_date_end}
                                        dsbzd_kh_id={info.dsbzd_kh_id}
                                        dsbzd_kh_name={info.dsbzd_kh_name}
                                        spjdList={props.spjdList}
                                        dsbzd_bm_id={info.dsbzd_bm_id}
                                        dsbzd_jd_id={info.dsbzd_jd_id}
                                        dsbzd_zb_id={info.dsbzd_zb_id}
                                    />
                                </Space>
                           </Form.Item>
                        </Col>
                    </Row>
                </Form>  
                <Divider />
                <IncomeListReport                   
                    yh_id={props.yh_id}
                    yh_name={props.yh_name}
                    dsbzd_id={props.dsbzd_id}
                    sr_data={info.sr_data}
                    dsbzd_date={info.dsbzd_date}
                    dsbzd_date_end={info.dsbzd_date_end}
                    dsbzd_name={info.dsbzd_name}
                    qy_id={props.qy_id}
                    qy_name={props.qy_name}
                    dsbzd_bm_id={info.dsbzd_bm_id}
                    dsbzd_bm_name={info.dsbzd_bm_name}
                    dsbzd_dscp_id={info.dsbzd_dscp_id}
                    dsbzd_dscp_name={info.dsbzd_dscp_name}
                    dsbzd_kh_id={info.dsbzd_kh_id}
                    dsbzd_kh_name={info.dsbzd_kh_name}
                    report_type='edit'
                />  
                <CostListReport         
                    yh_id={props.yh_id}
                    yh_name={props.yh_name}
                    dsbzd_id={props.dsbzd_id}
                    zc_data={info.zc_data}
                    dsbzd_date={info.dsbzd_date}
                    dsbzd_date_end={info.dsbzd_date_end}
                    dsbzd_name={info.dsbzd_name}
                    qy_id={props.qy_id}
                    qy_name={props.qy_name}
                    dsbzd_bm_id={info.dsbzd_bm_id}
                    dsbzd_bm_name={info.dsbzd_bm_name}
                    dsbzd_dscp_id={info.dsbzd_dscp_id}
                    dsbzd_dscp_name={info.dsbzd_dscp_name}
                    dsbzd_kh_id={info.dsbzd_kh_id}
                    dsbzd_kh_name={info.dsbzd_kh_name}
                    report_type='edit'
                />  
                <ExpenseListReport 
                    yh_id={props.yh_id}
                    yh_name={props.yh_name}
                    dsbzd_id={props.dsbzd_id}
                    fy_data={info.fy_data}  
                    qy_id={props.qy_id}
                    qy_name={props.qy_name}
                    dsbzd_uid={info.dsbzd_uid}
                    dsbzd_state={info.dsbzd_state}
                    dsbzd_date={info.dsbzd_date}    
                    dsbzd_date_end={info.dsbzd_date_end}
                    dsbzd_name={info.dsbzd_name}
                    dsbzd_bm_id={info.dsbzd_bm_id}
                    dsbzd_bm_name={info.dsbzd_bm_name}
                    dsbzd_dscp_id={info.dsbzd_dscp_id}
                    dsbzd_dscp_name={info.dsbzd_dscp_name}
                    dsbzd_kh_id={info.dsbzd_kh_id}
                    dsbzd_kh_name={info.dsbzd_kh_name}
                    report_type='edit'
                />  
                <LoanListReport  
                    yh_id={props.yh_id}
                    yh_name={props.yh_name}
                    dsbzd_id={props.dsbzd_id}
                    jk_data={info.jk_data}
                    qy_id={props.qy_id}
                    qy_name={props.qy_name}
                    dsbzd_uid={info.dsbzd_uid}
                    dsbzd_state={info.dsbzd_state}
                    dsbzd_date={info.dsbzd_date}
                    dsbzd_date_end={info.dsbzd_date_end}
                    dsbzd_name={info.dsbzd_name}
                    dsbzd_bm_id={info.dsbzd_bm_id}
                    dsbzd_bm_name={info.dsbzd_bm_name}
                    dsbzd_dscp_id={info.dsbzd_dscp_id}
                    dsbzd_dscp_name={info.dsbzd_dscp_name}
                    dsbzd_kh_id={info.dsbzd_kh_id}
                    dsbzd_kh_name={info.dsbzd_kh_name}
                    report_type='edit'
                />  
                <InvoiceListReport  
                    yh_id={props.yh_id}
                    yh_name={props.yh_name}
                    dsbzd_id={props.dsbzd_id}
                    kpsq_data={info.kpsq_data}
                    qy_id={props.qy_id}
                    qy_name={props.qy_name}
                    dsbzd_uid={info.dsbzd_uid}
                    dsbzd_state={info.dsbzd_state}
                    dsbzd_date={info.dsbzd_date}
                    dsbzd_date_end={info.dsbzd_date_end}
                    dsbzd_name={info.dsbzd_name}
                    dsbzd_bm_id={info.dsbzd_bm_id}
                    dsbzd_bm_name={info.dsbzd_bm_name}
                    dsbzd_dscp_id={info.dsbzd_dscp_id}
                    dsbzd_dscp_name={info.dsbzd_dscp_name}
                    dsbzd_kh_id={info.dsbzd_kh_id}
                    dsbzd_kh_name={info.dsbzd_kh_name}
                    report_type='edit'
                />  
               
                
                </Spin>
            </Modal>
        </>
    )
}

export default ReportEdit
